<template>
  <span class="bicon d-inline-block" @click="$emit('click', $event)">
    <font-awesome-icon v-if="Array.isArray(iconObject) || (typeof iconObject === 'string' && iconObject.substr(0,10) !== 'bobcaticon')"
                       :fixed-width="fixedWidth"
                       :rotation="rotation"
                       :flip="flip"
                       :icon="iconObject"
    />
    <bicon v-else :class="iconObject" />
  </span>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    icon: {
      required: true
    },
    fixedWidth: {
      required: false,
      default: false
    },
    flip: {
      type: String,
      required: false
    },
    rotation: {
      type: String,
      required: false
    }
  },
  computed: {
    iconObject() {
      if (this.icon === '~~~~~') return 'spinner'
      try {
        return JSON.parse(this.icon)
      } catch (e) {
        return this.icon
      }
    }
  }
}
</script>
